import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from "react-router-dom";
import { PagesHelper } from './common/PagesHelper';
import { Auth0Provider } from '@auth0/auth0-react';
import AuthGate from './auth/AuthGate';

window.permissions = [];
window.current_user = {};

/**
 * Turns URL path into router basename by removing everything after the last slash
 * @param {string} path URL path, probably window.location.pathname
 * @returns {string} final basename
 */
const getBasename = (path:string) : string => path.substring(0, path.lastIndexOf('/')) + '/';
const basename = getBasename(window.location.pathname);
PagesHelper.setBasePath(basename);
const redirect_uri = window.location.pathname.startsWith("/reporting-features/")
  ? "https://dashboard-stage.pronomix.ai/reporting-features"
  : window.location.origin + basename;

ReactDOM.render(
  <React.StrictMode>
    <Auth0Provider
      domain={process.env.REACT_APP_AUTH0_DOMAIN!}
      clientId={process.env.REACT_APP_AUTH0_CLIENT_ID!}
      authorizationParams={{
        redirect_uri: redirect_uri,
        audience: process.env.REACT_APP_AUTH0_AUDIENCE!,
        scope: "openid profile email"
      }}
    >
      <BrowserRouter basename={basename}>
        <AuthGate />
      </BrowserRouter>
    </Auth0Provider>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
